import { inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, exhaustMap, map, tap } from "rxjs/operators";
import { of } from "rxjs/internal/observable/of";
import { ResetPasswordService } from "../../services/reset-password.service";
import { findResetPasswordAct, findResetPasswordTokendAct, loadResetPasswordByIdAct, loadResetPasswordByTokenAct, saveResetPasswordAct, saveSuccessResetPasswordaAct, setViolationsResetPasswordAct, showMsgErrorAct, showMsgSuccessAct, updateResetPasswordAct, updateSuccessResetPasswordAct } from "./reset-password.actions";
import { AlertaService } from "../../services/alerta.service";

@Injectable()
export class ResetPasswordEffects {

    private actions$ = inject(Actions);
    private router = inject(Router);
    private resetPasswordService = inject(ResetPasswordService);
    private alerta = inject(AlertaService);

    findResetPasswordEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(findResetPasswordAct),
            exhaustMap(action => this.resetPasswordService.findResetPasswordById(action.id)
                .pipe(
                    map(resetPassword => loadResetPasswordByIdAct({ resetPassword })),
                    catchError(error => of(error))
                ))
        )
    );

    findResetPasswordTokenEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(findResetPasswordTokendAct),
            exhaustMap(action => this.resetPasswordService.findResetPasswordByToken(action.token)
                .pipe(
                    map(resetPassword => loadResetPasswordByTokenAct({ resetPassword })),
                    catchError(error => of(error))
                ))
        )
    );

    saveResetPasswordEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(saveResetPasswordAct),
            exhaustMap(action => this.resetPasswordService.saveResetPassword(action.resetPasswordNew)
                .pipe(
                    map(response => {
                        // Si el backend responde con 204 No Content, `response` será null
                        if (response === null) {
                            return showMsgSuccessAct({ msg: 'El correo ingresado no se encuentra registrado!' });
                        }
                        return saveSuccessResetPasswordaAct({ resetPasswordNew: response });
                    }
                    ),
                    catchError(error => (error.status == 400) ? of(setViolationsResetPasswordAct({ resetPasswordForm: action.resetPasswordNew, violations: this.violationsToObject(error.error.parameterViolations) })) : of(showMsgErrorAct({ error }))
                    )
                )
            )
        )
    );

    saveSuccessResetPasswordEffect$ = createEffect(() => this.actions$.pipe(
        ofType(saveSuccessResetPasswordaAct),
        tap(() => {
            this.router.navigate(['/login']);
            /*Swal.fire({
                title: "Creada nueva solicitud!",
                text: "Se ha enviado un correo para recuperar la cuenta",
                icon: "success"
            });*/
            this.alerta.correct("Se ha enviado un correo para recuperar la cuenta");
        })
    ), { dispatch: false }
    );

    updateResetPasswordEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(updateResetPasswordAct),
            exhaustMap(action => this.resetPasswordService.updateResetPassword(action.resetPasswordUpdated)
                .pipe(
                    map(resetPasswordUpdated => updateSuccessResetPasswordAct({ resetPasswordUpdated })),
                    catchError(error => (error.status == 400) ? of(setViolationsResetPasswordAct({ resetPasswordForm: action.resetPasswordUpdated, violations: this.violationsToObject(error.error.parameterViolations) })) : of(showMsgErrorAct({ error }))
                    )
                )
            )
        )
    );

    updateSuccessResetPasswordEffect$ = createEffect(() => this.actions$.pipe(
        ofType(updateSuccessResetPasswordAct),
        tap(() => {
            this.router.navigate(['/login']);

            /*Swal.fire({
                title: "Actualizado!",
                text: "Cuenta recuperada con exito!",
                icon: "success"
            });*/
            this.alerta.correct("Cuenta recuperada con exito!");
        })
    ), { dispatch: false });



    showMsgErrorEffect$ = createEffect(() => this.actions$.pipe(
        ofType(showMsgErrorAct),
        tap((action) => {
            /*Swal.fire({
                title: "Error",
                text: "Se ha precentado un error interno: " + action.error.message,
                icon: "error",
            });*/
            this.alerta.error("Se ha precentado un error interno: ", {detail: action.error.message});
        })
    ), { dispatch: false }
    );

    showMsgSuccessEffect$ = createEffect(() => this.actions$.pipe(
        ofType(showMsgSuccessAct),
        tap((action) => {
            /*Swal.fire({
                title: "Alerta",
                text: action.msg,
                icon: "warning",
            });*/
            this.alerta.error(action.msg, {detail: action.msg});
        })
    ), { dispatch: false }
    );

    violationsToObject(violationsList: []): any {
        return violationsList.reduce((obj: { [x: string]: any; }, item: { path: string; message: any; }) => {
            //obj[item.field.slice(item.field.lastIndexOf('.') + 1)] = item.message;
            //obj[item.field.slice(item.field.indexOf('.') + 1).replaceAll('.', '_')] = item.message;                obj[item.path.slice(item.path.indexOf('.') + 1)] = item.message;
            return obj;
        }, {});
    };

}